export class ThousandSeparatorValueConverter {
  toView(value) {
    if (value !== '' && value !== undefined && value !== 0 && value !== '0' && value !== null) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return value;
    }
  }
}